// Lib
import { Camera, CameraResultType } from '@capacitor/camera';
import { Dispatch } from 'redux';

// Utils
import { createElementAsync } from '../../element/actions/elementActions';
import { getNewTransactionId } from '../../utils/undoRedo/undoRedoTransactionManager';

// Constants
import { ElementType } from '../../../common/elements/elementTypes';
import { ELEMENT_CREATION_SOURCES } from '../../../common/elements/elementConstants';

/**
 * Uses the Camera Capacitor plugin to prompt the user to either take a photo or use the album picker
 * to create an image element.
 * @param dispatch Redux dispatch function from the calling component
 * @param location the location of  the image element that is going to be created
 */
export const createNewImageFromCameraOrAlbumPicker = async (dispatch: Dispatch<any>, location: any) => {
    const image = await Camera.getPhoto({
        resultType: CameraResultType.Base64,
        promptLabelHeader: 'Upload an image',
        promptLabelPhoto: 'Photo Library',
        promptLabelPicture: 'Take Photo',
    });
    const base64String = image.base64String;
    if (!base64String) return;

    const rawData = window.atob(base64String);
    const bytes = new Uint8Array(rawData.length);
    for (let i = 0; i < rawData.length; i++) {
        bytes[i] = rawData.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: `image/${image.format}}` });
    const filename = `photo-${Date.now()}.${image.format}`;
    const file = new File([blob], filename, { type: blob.type });

    dispatch(
        createElementAsync({
            attachment: file,
            elementType: ElementType.IMAGE_TYPE,
            location: location,
            creationSource: ELEMENT_CREATION_SOURCES.MOBILE_UPLOAD,
            transactionId: getNewTransactionId(),
        }),
    );
};
